<div class="this-week">
    <table class="table table-striped table-fixed forthcoming">
        @if (showInterviewer) {
        <thead class="sortable-header">
            <tr>
                <th [ngClass]="sortType('name')" class="appname" sortableuci="name" (sort)="onSort($event)">Name</th>
                <th [ngClass]="sortType('interviewer')" class="interviewer" sortableuci="interviewer"
                    (sort)="onSort($event)">Interviewer</th>
                <th [ngClass]="sortType('countryCode')" class="country" sortableuci="countryCode"
                    (sort)="onSort($event)">Country</th>
                <th [ngClass]="sortType('interviewDateTime')" class="date" sortableuci="interviewDateTime"
                    (sort)="onSort($event)">Date</th>
                <th class="time">Time</th>
            </tr>
        </thead>
        }
        <tbody>
            @for (w of sortedFilteredList; track w) {
            <tr [class.compact]="compact" (click)="openApplicant(w)">
                <td class="appname">
                    <span class="pimg">
                        <app-cf-profile [urlOrInitials]="w.profile" [width]="30" [height]="30"></app-cf-profile>
                    </span>
                    @if (w.status !== 'REJD') {
                    <span class="warnings">
                        @if (filter === '' && !w.isConfirmed) {
                        <span container="body" ngbPopover="Interview not confirmed" popoverClass="slot-popover"
                            triggers="mouseenter:mouseleave" popoverTitle="Note">
                            <i class="warning fa-solid fa-circle-exclamation"></i></span>
                        }
                        <!--<span @if (filter === '' && w.isLate) { container="body" ngbPopover="Interview is in the past"-->
                        @if (w.isLate) {
                        <span container="body" ngbPopover="Interview is in the past" popoverClass="slot-popover"
                            triggers="mouseenter:mouseleave" popoverTitle="Note">
                            <i class="warning-late fa-regular fa-calendar-xmark"></i></span>
                        }
                    </span>
                    {{w.name}}
                    }
                    @if (w.status === 'REJD' && !w.onlineInterviewsAllowed) {
                    <span class="warnings">
                        <span container="body" ngbPopover="Interview is rejected" popoverClass="slot-popover"
                            triggers="mouseenter:mouseleave" popoverTitle="Note">
                            <i class="warning fa-solid fa-circle-xmark"></i></span>
                    </span>
                    {{w.name}}
                    }
                </td>
                @if (showInterviewer) {
                <td class="interviewer">{{w.interviewer}}</td>
                <td class="country">{{w.countryCode}}</td>
                }
                @if (showTime) {
                <td class="date">{{w.displayDate}}</td>
                }
                @if (showTime) {
                <td class="time">{{w.displayTime}}</td>
                }
            </tr>
            }
        </tbody>
    </table>
</div>